export const zLayers = {
  // Negative layers
  behindBackground: -2,
  background: -1,

  // Base layers (0-10)
  default: 0,
  base: 1,
  contentBase: 2,
  controls: 3,

  // Interface layers (11-49)
  interface: 10,
  menu: 11,
  content: 20,

  // Overlay layers (50+)
  overlayBase: 50,
  overlayTop: 51,
  modal: 100,
  secondaryModal: 101,

  // Cropper & Quick Actions layers (1000+)
  cropper: 1000,
  cropperHandle: 1001,
  quickActions: 1002,

  // Item control overlay layer (2000+)
  // This layer is used to render item controls (selection border, icons, tooltips)
  // above all items regardless of their individual z-index
  itemControlOverlay: 2000,

  topLayer: 10000000000, // necessary to overlap 3rd party widgets like stonly

  // Toasts sit above every surface — including full-screen overlays like
  // the PDF proof viewer (topLayer) — or feedback such as the designer's
  // "proof sent" confirmation fires invisibly beneath them.
  toast: 10000000001,

  // Helper function for dynamic z-index
  getItemZ: (z: number | string | undefined) => (z ? Number(z!) + 1 : 1),
  addOne: (z: number | string | undefined) => Number(z!) + 1,
  getZ: (z: number | string | undefined) => Number(z!),
} as const

export default zLayers
